import { MeasureType } from '../../../learnware/LearnwareEnums';
export class AspectMountMeasureToWindow {
    parent;
    measureType;
    constructor(parent, measureType = MeasureType.BoundingClientRect) {
        this.parent = parent;
        this.measureType = measureType;
    }
    get aspectMount() {
        return this.parent;
    }
    get aspect() {
        return this.parent.aspect;
    }
    get measureReact() {
        if (this.measureType === MeasureType.BoundingClientRect) {
            return this.aspectMount.measureDom.expectedOrMeasuredBoundingClientRect;
        }
        return this.aspectMount.measureDom.expectedOrMeasuredOffset;
    }
    get aspectTopInPixel() {
        return Math.floor(this.measureReact.top);
    }
    get aspectLeftInPixel() {
        return Math.floor(this.measureReact.left);
    }
    get aspectLeftInUnits() {
        return Math.round(this.aspectLeftInPixel / this.aspect.context.stage.stageInnerMeasure.stageWidthRatio);
    }
    get aspectTopInUnits() {
        return Math.round(this.aspectTopInPixel / this.aspect.context.stage.stageInnerMeasure.stageHeightRatio);
    }
    get aspectBottomInPixel() {
        return this.aspectTopInPixel + this.aspectMount.mountDimensions.aspectHeightInPixel;
    }
    get aspectRightInPixel() {
        return this.aspectLeftInPixel + this.aspectMount.mountDimensions.aspectWidthInPixel;
    }
    get aspectLeftCenterInPixel() {
        return this.aspectLeftInPixel + this.aspectMount.mountDimensions.aspectWidthInPixel / 2;
    }
    get aspectTopCenterInPixel() {
        return this.aspectTopInPixel + this.aspectMount.mountDimensions.aspectHeightInPixel / 2;
    }
}
